<template>
	<div class="p_b" v-if="is_show">
		<a-icon class="close4" type="zoom-out" @click="smaller" />
		<a-icon class="close3" type="zoom-in" @click="bigger" />
		<a-icon class="close2" type="reload" @click="rotate" />
		<a-icon class="close" type="close" @click="is_show = false" />
		<div class="big_img" id="big_img" :style="{ width: w, height: h }" @mousewheel="mousewheel" @mousedown.stop="mousedown">
			<img :src="img" />
		</div>

		<a-button type="primary" class="clickBtn" @click="jian" v-if="idx != 0" style="left: 30px" shape="circle" icon="left"
		 size="large" ghost />
		<a-button type="primary" class="clickBtn" @click="add" v-if="idx != imgs.length - 1" style="right: 30px" shape="circle"
		 icon="right" size="large" ghost />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				is_show: false,
				img: '',
				w: '100%',
				h: '0',
				idx: 0,
				imgs: [],
				is_down: false,
				scale: 1,
				is_w_h: '',
				deg:0,
			}
		},
		mounted() {},
		methods: {
			rotate(){
				this.deg+=90
				$('#big_img').css({
					transform: 'rotate('+this.deg+'deg)'
				})
			},
			show(row) {
				this.scale = 1
				this.idx = row.index
				this.imgs = row.imgs
				if (this.imgs[this.idx].url) {
					this.img = this.imgs[this.idx].url
				} else {
					this.img = this.pyapi_url + this.imgs[this.idx]
				}
				this.is_show = true
				var im = new Image()
				im.onload = () => {
					let w = im.width
					let h = im.height
					if (w >= h) {
						this.h = 'auto'
						this.w = '60%'
						this.is_w_h = 'w'
					} else {
						this.h = '95%'
						this.w = 'auto'
						this.is_w_h = 'h'
					}
				}
				im.src = this.img
			},
			jian() {
				this.idx -= 1
				if (this.imgs[this.idx].url) {
					this.img = this.imgs[this.idx].url
				} else {
					this.img = this.pyapi_url + this.imgs[this.idx]
				}
				var im = new Image()
				im.onload = () => {
					let w = im.width
					let h = im.height
					if (w >= h) {
						this.h = 'auto'
						this.w = '60%'
						this.is_w_h = 'w'
						$('#big_img').css({
							width: '60%',
							height: 'initial'
						})
					} else {
						this.h = '95%'
						this.w = 'auto'
						this.is_w_h = 'h'
						$('#big_img').css({
							width: 'initial',
							height: '95%'
						})
					}
					$('#big_img').css({
						left: 'initial',
						top: 'initial'
					})
				}
				im.src = this.img
			},
			add() {
				console.log('add')
				this.idx += 1
				if (this.imgs[this.idx].url) {
					this.img = this.imgs[this.idx].url
				} else {
					this.img = this.pyapi_url + this.imgs[this.idx]
				}
				var im = new Image()
				im.onload = () => {
					let w = im.width
					let h = im.height
					if (w >= h) {
						this.h = 'auto'
						this.w = '60%'
						this.is_w_h = 'w'
						$('#big_img').css({
							width: '60%',
							height: 'initial'
						})
					} else {
						this.h = '95%'
						this.w = 'auto'
						this.is_w_h = 'h'
						$('#big_img').css({
							width: 'initial',
							height: '95%'
						})
					}
					$('#big_img').css({
						left: 'initial',
						top: 'initial'
					})
				}
				im.src = this.img + '&time=' + new Date().getTime()
			},
			mousedown(event) {
				var s_t = $('#big_img').position().top
				var s_l = $('#big_img').position().left
				var c_t = event.clientY
				var c_l = event.clientX
				event.stopPropagation()
				event.preventDefault()
				$('#big_img').mousemove((e) => {
					e.stopPropagation()
					let m_t = e.clientY
					let m_l = e.clientX
					$('#big_img').css({
						left: m_l - c_l + s_l,
						top: m_t - c_t + s_t
					})
				})
				$('#big_img').mouseup((e) => {
					e.stopPropagation()
					$('#big_img').unbind('mousemove')
				})
			},
			bigger() {
				var b_w = $('#big_img').width()
				var b_h = $('#big_img').height()
			
				b_h += 100
				$('#big_img').css({
					height: b_h + 'px'
				})
			
				b_w += 100
				$('#big_img').css({
					width: b_w + 'px'
				})
			
			},
			smaller() {
				var b_w = $('#big_img').width()
				var b_h = $('#big_img').height()
			
				b_h -= 100
				$('#big_img').css({
					height: b_h + 'px'
				})
			
				b_w -= 100
				$('#big_img').css({
					width: b_w + 'px'
				})
			
			},
			mousewheel(e) {
				var b_w = $('#big_img').width()
				var b_h = $('#big_img').height()
				let direction = e.deltaY > 0 ? 'down' : 'up'
				if (direction == 'up') {
						b_h += 50
						$('#big_img').css({
							height: b_h + 'px'
						})
					
						b_w += 50
						$('#big_img').css({
							width: b_w + 'px'
						})
					
				} else {
					
						b_h -= 50
						$('#big_img').css({
							height: b_h + 'px'
						})
					
						b_w -= 50
						$('#big_img').css({
							width: b_w + 'px'
						})
					
				}
			},
		},
	}
</script>

<style scoped lang="less">
	.p_b {
		width: 100%;
		height: 100vh;
		float: left;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999999;
		background: rgba(0, 0, 0, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;

		.clickBtn {
			position: absolute;
			top: 50%;
		}
		.close4 {
			position: absolute;
			right: 180px;
			top: 30px;
			font-size: 26px;
			color: deepskyblue;
			z-index: 999;
			cursor: pointer;
		}
		
		.close3 {
			position: absolute;
			right: 130px;
			top: 30px;
			font-size: 26px;
			color: deepskyblue;
			z-index: 999;
			cursor: pointer;
		}
		.close {
			position: absolute;
			right: 30px;
			top: 30px;
			font-size: 26px;
			color: red;
			z-index: 999;
			cursor: pointer;
		}
		.close2 {
			position: absolute;
			right: 80px;
			top: 30px;
			font-size: 26px;
			color: deepskyblue;
			z-index: 999;
			cursor: pointer;
		}

		.big_img {
			position: absolute;
			// transform: translate(-50%, -50%);
			cursor: move;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}
</style>
